export default __webpack_public_path__ + "static/media/games.e8098bee.svg";